import * as React from "react";

function DownloadIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={25} fill="none" {...props}>
      <path
        d="M12 16.5l-5-5 1.4-1.45 2.6 2.6V4.5h2v8.15l2.6-2.6L17 11.5l-5 5zm-6 4c-.55 0-1.021-.196-1.413-.588A1.922 1.922 0 014 18.5v-3h2v3h12v-3h2v3c0 .55-.196 1.021-.588 1.413A1.922 1.922 0 0118 20.5H6z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoDownloadIcon = React.memo(DownloadIcon);
export default MemoDownloadIcon;
